<template>
  <div id="pageDashboard">
    <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <v-flex xs12>
          <v-alert type="warning" color="orange" prominent>
            <div class="mb-2">
              Air Quality Testing with Lawrence Factor and X-zam Labs will no
              longer be available as we transition our testing to Trace
              Analytics. Please contact our customer service team at
              305-430-0550 or support@lawrence-factor.com
            </div>
            <div>
              Our current filtration product will go unchanged, and all of those
              products are readily available as normal.
            </div>
          </v-alert>
        </v-flex>

        <!-- mini statistic start -->
        <v-flex lg3 sm6 xs12>
          <router-link to="/clients">
            <mini-statistic
              icon="mdi-warehouse"
              :title="clientAccounts.length.toString()"
              sub-title="Client Accounts"
              color="cyan"
            >
            </mini-statistic>
          </router-link>
        </v-flex>

        <v-flex lg3 sm6 xs12>
          <router-link to="/users">
            <mini-statistic
              icon="mdi-account-hard-hat"
              :title="activeTechnicians.length.toString()"
              sub-title="Active Technicians"
              color="error"
            >
            </mini-statistic>
          </router-link>
        </v-flex>

        <v-flex lg3 sm6 xs12>
          <router-link to="/lols">
            <mini-statistic
              icon="mdi-tablet-cellphone"
              :title="lolsDeployed.length.toString()"
              sub-title="LOLs Deployed"
              color="deep-orange"
            >
            </mini-statistic>
          </router-link>
        </v-flex>

        <v-flex lg3 sm6 xs12>
          <router-link :to="testsPendingRoute">
            <mini-statistic
              icon="mdi-test-tube"
              :title="testsPendingApproval.toString()"
              sub-title="Tests Pending Approval"
              color="success"
            >
            </mini-statistic>
          </router-link>
        </v-flex>

        <v-flex xs12>
          <router-link to="/certificates">
            <mini-statistic-expanded
              icon="mdi-certificate"
              :title="certsToday.length.toString()"
              :title2="certsWeek.length.toString()"
              :title3="certsMonth.length.toString()"
              sub-title="Certs Issued Today"
              sub-title2="Certs Issued This Week"
              sub-title3="Certs Issued This Month"
              color="light-blue"
              color2="blue"
              color3="indigo"
            >
            </mini-statistic-expanded>
          </router-link>
        </v-flex>

        <v-flex lg8 xs12>
          <template>
            <v-card
              class="mx-auto text-center"
              color="info"
              dark
              :loading="weeklyCertsLoading"
            >
              <template slot="progress">
                <v-progress-linear
                  color="white"
                  indeterminate
                ></v-progress-linear>
              </template>
              <v-card-title>
                <v-icon color="white" class="d-none d-md-block mr-12" size="64">
                  mdi-test-tube
                </v-icon>
                <v-icon color="white" class="d-md-none mr-12" size="32">
                  mdi-test-tube
                </v-icon>
                <v-row align="start">
                  <div class="text-subtitle-1 text-md-h4 font-weight-thin">
                    3 Month History (Weekly)
                  </div>
                </v-row>

                <v-spacer></v-spacer>

                <v-btn
                  icon
                  class="align-self-start"
                  @click="$router.push('certificates')"
                >
                  <v-icon>mdi-arrow-right</v-icon>
                </v-btn>
              </v-card-title>

              <v-card-text>
                <v-sparkline
                  v-if="!weeklyCertsLoading"
                  :value="weeklyCerts"
                  :labels="weeklyCerts"
                  label-size="5"
                  color="rgba(255, 255, 255, .8)"
                  height="50"
                  line-width="1"
                  stroke-linecap="round"
                  smooth
                  auto-draw
                ></v-sparkline>
              </v-card-text>
            </v-card>
          </template>
        </v-flex>

        <!-- <v-flex lg4 xs12>
          <NotificationList />
        </v-flex> -->
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import MiniStatistic from '@/components/dashboard/MiniStatistic'
import MiniStatisticExpanded from '@/components/dashboard/MiniStatisticExpanded'
// import NotificationList from "@/components/NotificationList.vue"
import AuthService from '../services/auth.service'
import LolService from '../services/lol.service'
import CustomerService from '../services/customer.service'
import TestService from '../services/test.service'
import CertService from '../services/cert.service'

export default {
  components: {
    MiniStatistic,
    MiniStatisticExpanded
    // NotificationList
  },
  data: () => ({
    activeTechnicians: [],
    lolsDeployed: [],
    clientAccounts: [],
    testsPendingApproval: 0,
    certsToday: [],
    certsWeek: [],
    certsMonth: [],
    certsQuarter: [],
    weeklyCertsCount: 0,
    weeklyCerts: [],
    weeklyCertsLabels: [],
    weeklyCertsLoading: true,
    value: [0, 0],
    testsPendingRoute: ''
  }),

  created() {
    this.initialize()
  },

  computed: {
    currentUser() {
      return this.$store.state.auth.user
    },

    checkRole(role) {
      if (Array.isArray(role)) {
        var i
        for (i = 0; i < role.length; i++) {
          if (this.currentUser.roles.includes(role[i])) {
            return true
          }
          if (role[i] == 'lf') {
            if (
              this.currentUser.roles.includes('ROLE_LFADMIN') ||
              this.currentUser.roles.includes('ROLE_LFTECH') ||
              this.currentUser.roles.includes('ROLE_LFBILLING')
            ) {
              return true
            }
          }
          if (role[i] == 'dealer') {
            if (
              this.currentUser.roles.includes('ROLE_DEALERADMIN') ||
              this.currentUser.roles.includes('ROLE_DEALERTECH')
            ) {
              return true
            }
          }
        }
        return false
      }

      if (role == 'lf') {
        if (
          this.currentUser.roles.includes('ROLE_LFADMIN') ||
          this.currentUser.roles.includes('ROLE_LFTECH') ||
          this.currentUser.roles.includes('ROLE_LFBILLING')
        ) {
          return true
        }
      }

      if (role == 'dealer') {
        if (
          this.currentUser.roles.includes('ROLE_DEALERADMIN') ||
          this.currentUser.roles.includes('ROLE_DEALERTECH')
        ) {
          return true
        }
      }

      if (this.currentUser.roles.includes(role)) {
        return true
      } else {
        return false
      }
    }
  },

  methods: {
    async initialize() {
      this.retrieveActiveTechnicians()
      await this.retrieveLolsDeployed()
      this.retrieveClientAccounts()
      this.retrieveTestsPendingApproval()
      this.retrieveCertsIssuedToday()
      this.retrieveCertsIssuedWeek()
      this.retrieveCertsIssuedMonth()
      this.retrieveCertsIssuedQuarter()
      this.setTestsPendingRoute()
    },

    setTestsPendingRoute() {
      if (
        this.currentUser.roles.includes('ROLE_LFADMIN') ||
        this.currentUser.roles.includes('ROLE_LFTECH') ||
        this.currentUser.roles.includes('ROLE_LFBILLING')
      ) {
        this.testsPendingRoute = '/certreview'
      }
    },

    retrieveActiveTechnicians() {
      AuthService.getCustomerUsers(this.currentUser.customerID)
        .then(async (response) => {
          this.activeTechnicians = response.data || []

          return new Promise((resolve) => {
            resolve('Done')
          })
        })
        .catch((e) => {
          console.log(e)
          window._LOL2P.$emit('SHOW_SNACKBAR', {
            text: 'There was an error retrieving active technicians',
            color: 'error'
          })
        })
    },

    async retrieveLolsDeployed() {
      await LolService.getCustomerLols(this.currentUser.customerID)
        .then(async (response) => {
          this.lolsDeployed = response.data || []

          return new Promise((resolve) => {
            resolve('Done')
          })
        })
        .catch((e) => {
          console.log(e)
          window._LOL2P.$emit('SHOW_SNACKBAR', {
            text: 'There was an error retrieving LOLs deployed',
            color: 'error'
          })
        })
    },

    retrieveClientAccounts() {
      CustomerService.getDealerClients(this.currentUser.customerID)
        .then(async (response) => {
          this.clientAccounts = response.data || []

          return new Promise((resolve) => {
            resolve('Done')
          })
        })
        .catch((e) => {
          console.log(e)
          window._LOL2P.$emit('SHOW_SNACKBAR', {
            text: 'There was an error retrieving client accounts',
            color: 'error'
          })
        })
    },

    retrieveTestsPendingApproval() {
      for (const lol of this.lolsDeployed) {
        TestService.getLolTestsPendingApproval(lol.lolID)
          .then(async (response) => {
            this.testsPendingApproval += response.data.length

            return new Promise((resolve) => {
              resolve('Done')
            })
          })
          .catch((e) => {
            console.log(e)
            window._LOL2P.$emit('SHOW_SNACKBAR', {
              text: 'There was an error retrieving tests pending approval',
              color: 'error'
            })
          })
      }
    },

    retrieveCertsIssuedToday() {
      var createdAfter = new Date()
      createdAfter.setDate(createdAfter.getDate() - 1)
      createdAfter = createdAfter.toISOString()

      CertService.getCustomerCertsCreatedAfter(
        this.currentUser.customerID,
        createdAfter
      )
        .then(async (response) => {
          this.certsToday = response.data || []

          return new Promise((resolve) => {
            resolve('Done')
          })
        })
        .catch((e) => {
          console.log(e)
          window._LOL2P.$emit('SHOW_SNACKBAR', {
            text: 'There was an error retrieving certs issued today',
            color: 'error'
          })
        })
    },

    retrieveCertsIssuedWeek() {
      var createdAfter = new Date()
      createdAfter.setDate(createdAfter.getDate() - 8)
      createdAfter = createdAfter.toISOString()

      CertService.getCustomerCertsCreatedAfter(
        this.currentUser.customerID,
        createdAfter
      )
        .then(async (response) => {
          this.certsWeek = response.data || []

          return new Promise((resolve) => {
            resolve('Done')
          })
        })
        .catch((e) => {
          console.log(e)
          window._LOL2P.$emit('SHOW_SNACKBAR', {
            text: 'There was an error retrieving certs issued this week',
            color: 'error'
          })
        })
    },

    retrieveCertsIssuedMonth() {
      var createdAfter = new Date()
      createdAfter.setDate(createdAfter.getDate() - 31)
      createdAfter = createdAfter.toISOString()

      CertService.getCustomerCertsCreatedAfter(
        this.currentUser.customerID,
        createdAfter
      )
        .then(async (response) => {
          this.certsMonth = response.data || []

          return new Promise((resolve) => {
            resolve('Done')
          })
        })
        .catch((e) => {
          console.log(e)
          window._LOL2P.$emit('SHOW_SNACKBAR', {
            text: 'There was an error retrieving certs issued this month',
            color: 'error'
          })
        })
    },

    async retrieveCertsIssuedQuarter() {
      for (let i = 1; i < 14; i++) {
        var createdAfter = new Date()
        createdAfter.setDate(createdAfter.getDate() - 8 * i)
        createdAfter = createdAfter.toISOString()

        await CertService.getCustomerCertsCreatedAfter(
          this.currentUser.customerID,
          createdAfter
        )
          .then(async (response) => {
            let count = response.data.length - this.weeklyCertsCount
            this.weeklyCerts.unshift(count)
            // this.weeklyCertsLabels.unshift(`Wk ${14 - i} - ${count}`)
            // this.weeklyCertsLabels.unshift(`${count} ${(count > 1)?'tests':'test'}`)
            this.weeklyCertsCount += count

            return new Promise((resolve) => {
              resolve('Done')
            })
          })
          .catch((e) => {
            console.log(e)
            window._LOL2P.$emit('SHOW_SNACKBAR', {
              text: 'There was an error retrieving certs issued this quarter',
              color: 'error'
            })
          })
      }
      this.weeklyCertsLoading = false
    }
  }
}
</script>

<style scoped>
a:hover,
a:visited,
a:link,
a:active {
  text-decoration: none;
}
</style>
